import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ViewLogsDialogComponent } from './view-logs-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ViewLogsDialogService {

  constructor(private modalService: NgbModal) { }

  public confirm(
    viewobj:Object,
    title: string,
    message: string,
    btnOkText: string = 'Yes',
    btnCancelText: string = 'No',
    dialogSize: 'sm'|'lg' = 'sm'): Promise<boolean> {
    const modalRef = this.modalService.open(ViewLogsDialogComponent, { size: dialogSize });
    modalRef.componentInstance.viewobj = viewobj;
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }
}
